export default {
  path: '/reviews/summary',
  component: () => import('../views/Review/LayoutReview.vue'),
  children: [
    {
      path: '/reviews/list',
      component: () => import('../views/Review/Response/LayoutResponse.vue'),
      children: [
        {
          path: '',
          name: 'review list',
          component: () => import('../views/Review/Response/PageList.vue'),
        },
        {
          path: '/review/:id',
          props: true,
          name: 'review show',
          component: () => import('../views/Review/Response/Show/PageShow.vue'),
        },
      ],
    },
    {
      path: '',
      name: 'review summary',
      component: () => import('../views/Review/Summary/PageSummary.vue'),
    },
    {
      path: '/reviews/form',
      name: 'review form',
      component: () => import('../views/Review/Form/PageForm.vue'),
    },
  ],
}
